import React, { useEffect, useState } from "react";
import { useContext } from "react";
import "../assets/css/style.css";
import "../assets/css/responsive.css";
import Header from "../Components/Header/HeaderNew";
import OurServices from "../Components/OurServices/OurServices";
import OurFacility from "../Components/OurFacility/OurFacility";
import ContactUs from "../Components/ContactUs/ContactUs";
import Footer from "../Components/Footer/Footer";
import { VimeoContext } from "./VimeoContext";
import { Helmet } from "react-helmet";
import { isBrowser, isMobile } from 'react-device-detect';
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import LogoImage from "../assets/images/logo_text.png";
import HeroImage from "../assets/images/Grass_Clippings_Rolling_Hills_Logo_Sand.png";

import { Spinner, Modal } from 'react-bootstrap';
import { BsChevronDown } from "react-icons/bs";
import { IoClose } from "react-icons/io5";

import axios from 'axios';
import { API_URL } from "../Api/config";


function Grassy() {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    })


    const [validated, setValidated] = useState(false);
    const [fName, setFName] = useState('');
    const [lName, setLName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [dexterity, setDexterity] = useState('');
    const [preferredTime, setPreferredTime] = useState('');
    const [description, setDescription] = useState('');
    const [apicall, setApicall] = useState(false);
    const [serverSideError, setServerSideError] = useState(null);

    const timeArray = [
         "Morning","Afternoon","Evening"
    ] ;

    const dexterityArray = [
        "Left","Right"
    ];

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleSubmit = (event) => {
        event.preventDefault(); // Prevent form from submitting the default way
    
        const form = event.currentTarget;
    
        if (form.checkValidity() === false) {
            event.stopPropagation(); // Stop further event propagation if form is invalid
            setValidated(true); // Set form validation state
        } else {
            setApicall(true); // Indicate API call in progress
    
            // Your form submission logic here
            const data = {
                firstName: fName,
                lastName: lName,
                phoneNumber: phone,
                email: email,
                description: description,
                preferredtime: timeArray[preferredTime],
                dexterity: dexterityArray[dexterity], 
                subject: "grassy" // Hardcoded subject for this context
            };
    
            axios.post(API_URL + 'contact/submit-event', data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                console.log("response", response);
                handleShow(); // Show confirmation/modal on success
                
                // Reset form fields
                setFName('');
                setLName('');
                setPhone('');
                setEmail('');
                setDescription('');
                setServerSideError(null); // Clear server-side error if successful
            })
            .catch(error => {
                console.error("error", error);
                // Set the server-side error message
                setServerSideError(error.response?.data || "An error occurred. Please try again.");
            })
            .finally(() => {
                setApicall(false); // Reset API call state
                setValidated(false); // Reset form validation state
            });
        }
    
        setValidated(true); // Set form validation state
    };
    
    // const handleSubmit = (event) => {
    //     event.preventDefault();
    //     const form = event.currentTarget;
    //     if (form.checkValidity() === false) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //     } else {
    //         setApicall(true);
    //         //handleShow();
    //         // Your form submission logic here

    //         axios.post(API_URL + 'contact/contactSubmitevent', {
    //             firstName: fName,
    //             lastName: lName,
    //             phoneNumber: phone,
    //             email: email,
    //             description: description,
    //             subject: "grassy"
    //         }
    //             , {
    //                 headers: {
    //                     'Content-Type': 'application/json'
    //                 }
    //             })
    //             .then(response => {
    //                 console.log("response", response);
    //                 handleShow();
    //                 setFName('');
    //                 setLName('');
    //                 setPhone('');
    //                 setEmail('');
    //                 setDescription('');
    //                 setServerSideError(null);
    //                 // do something with response, like setting a success message state
    //             })
    //             .catch(error => {
    //                 console.log("error", error);
    //                 setServerSideError(error.response.data);
    //                 // handle the error
    //             }).finally(() => {
    //                 setApicall(false);
    //                 setValidated(false);
    //             });
    //     }
    //     setValidated(true);
    // };



    return (
        <>

            <Helmet>
                <title>About Us</title>
                <meta name="description" content="When it comes to equipment we are completely brand agnostic. With the golf swing we believe there are many ways to get it done. We are golfers, not salesmen." />
                <link rel="canonical" href="https://foreward.golf/about-us" />
                <meta property="og:url" content="https://foreward.golf/about-us" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="About Us" />
                <meta property="og:description" content="When it comes to equipment we are completely brand agnostic. With the golf swing we believe there are many ways to get it done. We are golfers, not salesmen." />
                <meta property="og:image" content={`${process.env.REACT_APP_SITE_URL}logo_icon.png`} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta property="twitter:domain" content="foreward.golf" />
                <meta property="twitter:url" content="https://foreward.golf/about-us" />
                <meta name="twitter:title" content="About Us" />
                <meta name="twitter:description" content="When it comes to equipment we are completely brand agnostic. With the golf swing we believe there are many ways to get it done. We are golfers, not salesmen." />
                <meta name="twitter:image" content={`${process.env.REACT_APP_SITE_URL}logo_icon.png`} />


            </Helmet>

            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../assets/images/forewardFormSubmit.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your message is sent!
                    </h3>
                    <p className="text-center mb-0">
                        Our staff will be in contact shortly to answer any questions and get you sorted.
                    </p>
                </Modal.Body>
            </Modal>


            <Header />
            <section id="hero" className="hero img_bg page-section">
                {width > 480 ? (
                    <div className="iframe-hero"> 
                        <iframe loading="eager" src="https://player.vimeo.com/video/1011454294?autoplay=1&controls=0&loop=1&muted=1" frameBorder={0} allowFullScreen webkit-playsinline playsinline />
                    </div>
                ) : (
                    <div className="iframe-hero">
                        <iframe loading="eager" src="https://player.vimeo.com/video/1011454294?autoplay=1&controls=0&loop=1&muted=1" frameBorder={0} allowFullScreen webkit-playsinline playsinline />
                    </div>
                )}

                <div className="container-xl">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hero_content">
                                <img src={HeroImage} />

                                <div className="arrow_animation show_mobile bounce pt-3">
                                    <i className="bi bi-arrow-down-short" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="about-form-element" style={{ backgroundColor: '#272a31', minHeight: '100vh' }}>
                <Container className="d-flex flex-column align-items-center text-center">
                    <div className="form-element-event-list">
                        <img src={LogoImage} />
                        <h2 style={{ color: '#fff', fontWeight: 'bold' }}>Course:</h2>
                        <p style={{ color: '#fff' }}>Grass Clippings Rolling Hills</p>
                        <h3 style={{ color: '#fff' }}>Where:</h3>
                        <p style={{ color: '#fff' }}>1415 N Mill Ave, Tempe, AZ 85288</p>
                        <h3 style={{ color: '#fff' }}>What:</h3>
                        <p style={{ color: '#fff' }}>
                            Foreward will be performing fittings<br />
                            October 25-26 from 9 to 5
                        </p>
                    </div>

                    <div className="box-light-black-form">
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <div className="row gx-2">
                                <div className="col-md-6 form-group" controlid="validationCustom01">
                                    <input
                                        type="text"
                                        name="f-name"
                                        className="form-control"
                                        placeholder="First name"
                                        value={fName}
                                        onChange={(e) => setFName(e.target.value)}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a first name.
                                    </Form.Control.Feedback>
                                </div>

                                <div className="col-md-6 form-group" controlid="validationCustom02">
                                    <input
                                        type="text"
                                        name="l-name"
                                        className="form-control"
                                        placeholder="Last name"
                                        value={lName}
                                        onChange={(e) => setLName(e.target.value)}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a last name.
                                    </Form.Control.Feedback>
                                </div>

                                <div className="col-md-12 form-group" controlid="validationCustom03">
                                    <input
                                        type="tel"
                                        name="phone"
                                        pattern="[0-9]{8,}"
                                        title="Please enter an 8-digit phone number."
                                        className="form-control"
                                        placeholder="Phone"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ''))}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a valid phone number.
                                    </Form.Control.Feedback>
                                </div>

                                <div className="col-md-12 form-group" controlid="validationCustom04">
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a valid email.
                                    </Form.Control.Feedback>
                                </div>

                                <div className="col-md-6 form-group select-box-arrow">
                                    <select
                                        className="form-control"
                                        name="dexterity"
                                        value={dexterity}
                                        onChange={(e) => setDexterity(e.target.value)}
                                        required
                                    >
                                        <option value="">Dexterity</option>
                                        <option value="0">Left</option>
                                        <option value="1">Right</option>
                                    </select>

                                    <BsChevronDown />

                                    <Form.Control.Feedback type="invalid">
                                        Please select dexterity.
                                    </Form.Control.Feedback>
                                </div>

                                <div className="col-md-6 form-group select-box-arrow">
                                    <select
                                        className="form-control"
                                        name="preferredTime"
                                        value={preferredTime}
                                        onChange={(e) => setPreferredTime(e.target.value)}
                                        required
                                    >
                                        <option value="">Preferred Time</option>
                                        <option value="0">Morning</option>
                                        <option value="1">Afternoon</option>
                                        <option value="2">Evening</option>
                                    </select>

                                    <BsChevronDown />

                                    <Form.Control.Feedback type="invalid">
                                        Please select a preferred time.
                                    </Form.Control.Feedback>
                                </div>

                                <div className="col-md-12 form-group ">
                                    <textarea
                                        className="form-control"
                                        name="message"
                                        placeholder="Anything you want us to know?"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        rows={5}
                                        required
                                    ></textarea>
                                </div>


                                <div className="col-md-12 text-center">
                                    <Button className="btn btn-dark btn-block form-btn form-btn-request-submit" type="submit">
                                        {apicall ? <Spinner animation="grow" variant="light" /> : <span>Request your fitting</span>}
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </div>

                </Container>
            </div>
            <ContactUs />
            <Footer />
        </>

    );
}

export default Grassy;

